import React from 'react';
import { RefreshCw } from 'lucide-react';
import { canSyncKnowledgeBase } from '../constants';

function SyncButton({
  kb,
  isSyncing,
  onSync,
  compact = false,
  className,
}) {
  const canSync = canSyncKnowledgeBase(kb);
  const disabled = !canSync || isSyncing;
  const label = isSyncing ? 'Sincronizando...' : 'Sincronizar';
  const ariaLabel = isSyncing
    ? 'Sincronizando base de conhecimento'
    : 'Sincronizar base de conhecimento';

  const defaultClassName = compact
    ? 'inline-flex items-center justify-center h-8 w-8 rounded-lg border border-surface-border bg-white text-content-secondary hover:bg-slate-50 hover:text-content-primary disabled:opacity-40 transition-colors'
    : 'btn-secondary text-xs px-3 py-2 disabled:opacity-40 whitespace-nowrap inline-flex items-center gap-1.5';

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onSync(kb)}
      className={className || defaultClassName}
      title={label}
      aria-label={ariaLabel}
    >
      <RefreshCw className={`h-3.5 w-3.5 shrink-0 ${isSyncing ? 'animate-spin' : ''}`} aria-hidden />
      {!compact && (isSyncing ? 'Sincronizando...' : 'Sincronizar')}
    </button>
  );
}

export default SyncButton;
